import React from 'react';
import MeetingFeedbacksBody from './body';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import { getDefaultWidgetConfigs, getRemoteConfigs, getEventDetailsHash } from '../utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

const MeetingFeedbacks = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "grid-item-span-full-width" });
  const filterKey = 'respondedIn';

  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MeetingFeedbacksBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'responded_in_date_range') })
    };
  };

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      trackOnLoad={ props.trackOnLoad }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default MeetingFeedbacks;
